// Copyright 1999-2017. Plesk International GmbH. All rights reserved.

import { createElement, isValidElement } from '../../utils';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { CLS_PREFIX } from '../../constants';
import Icon, { ICON_SIZE_16, ICON_SIZE_24, ICON_SIZE_32, ICON_SIZE_48, ICON_SIZE_64, ICON_SIZE_96, ICON_SIZE_128, ICON_SIZE_192 } from '../Icon';

import './Media.less';

/**
 * `Media` component.
 */
const Media = ({
    baseClassName,
    className,
    children,
    title,
    titleAddon,
    titleSize,
    image,
    imageSpacing,
    ...props
}) => {
    if (!imageSpacing && isValidElement(image) && image.type === Icon) {
        const map = {
            [ICON_SIZE_16]: 'sm',
            [ICON_SIZE_24]: 'md',
            [ICON_SIZE_32]: 'md',
            [ICON_SIZE_48]: 'lg',
            [ICON_SIZE_64]: 'xl',
            [ICON_SIZE_96]: 'xxl',
            [ICON_SIZE_128]: 'xxl',
            [ICON_SIZE_192]: 'xxl',
        };
        imageSpacing = map[image.props.size];
    }

    return (
        <div className={classNames(baseClassName, className)} {...props}>
            {image && (
                <figure
                    className={classNames(
                        `${baseClassName}__figure`,
                        { [`${baseClassName}__figure--${imageSpacing}`]: imageSpacing }
                    )}
                >
                    {image}
                </figure>
            )}
            <div className={`${baseClassName}__body`}>
                {title || titleAddon ? (
                    <div
                        className={classNames(
                            `${baseClassName}__header`,
                            { [`${baseClassName}__header--${titleSize}`]: titleSize }
                        )}
                    >
                        {title && <h4 className={`${baseClassName}__title`}>{title}</h4>}
                        {titleAddon && <div className={`${baseClassName}__title-addon`}>{titleAddon}</div>}
                    </div>
                ) : null}
                <div className={`${baseClassName}__content`}>
                    {children}
                </div>
            </div>
        </div>
    );
};

Media.propTypes = {
    /**
     * Title
     */
    title: PropTypes.node,
    /**
     * Title addon
     */
    titleAddon: PropTypes.node,
    /**
     * Title size
     */
    titleSize: PropTypes.oneOf(['md', 'lg', 'xl']),
    /**
     * Image
     */
    image: PropTypes.any,
    /**
     * Spacings between image and content
     */
    imageSpacing: PropTypes.oneOf(['sm', 'md', 'lg', 'xl', 'xxl']),
    /**
     * Content of the `Media`.
     */
    children: PropTypes.node,
    /**
     * @ignore
     */
    className: PropTypes.string,
    /**
     * @ignore
     */
    baseClassName: PropTypes.string,
};
Media.defaultProps = {
    title: null,
    titleAddon: null,
    titleSize: null,
    image: null,
    imageSpacing: null,
    children: null,
    className: null,
    baseClassName: `${CLS_PREFIX}media`,
};

export default Media;



// WEBPACK FOOTER //
// ./components/Media/Media.js